<div>
    @if (!showEmail) {
        <div>
            @if (v2NavEnabledPreLogin) {
                <div>
                    <lh-header-bar
                        class="d-flex d-sm-none"
                        [content]="headerTitle"
                        [disableClose]="newAccountMenuService.isEpcotMenuEnabled()"
                        [showBackButton]="redirectedFromSASWFlow ? false : true"
                        (onBack)="gotoLastKnownProduct(screenName, 'Back')"
                        (onClose)="gotoLastKnownProduct(screenName, 'Close')"></lh-header-bar>
                    <ng-container *ngTemplateOutlet="contactTemplate"></ng-container>
                </div>
            }
            @if (v2NavEnabled && loggedInUser && !newAccountMenuService.isEpcotMenuEnabled()) {
                <lh-navigation-layout-page
                    sourceItem="help"
                    [hideCloseButton]="newAccountMenuService.isEpcotMenuEnabled()"
                    [topMenuVisibility]="newAccountMenuService.hideTopMenu('help')">
                    <ng-container *ngTemplateOutlet="contactTemplate"></ng-container>
                </lh-navigation-layout-page>
            }
        </div>
    }
    @if (showEmail) {
        <div>
            @if (helpAndContactData.showEmailScreen) {
                <div id="contact-options">
                    <pt-email-option
                        [contactData]="emailScreenContactData"
                        [enableDragAndDrop]="initData.enableDragAndDrop"
                        [isNewDobEnabled]="initData.isNewDobEnabled"
                        (disableEmailScreen)="disableEmailScreen($event)"></pt-email-option>
                </div>
            }
        </div>
    }
</div>
<ng-template #contactTemplate>
    @if (!optionsScreen) {
        <div id="contact">
            @if (!initData.helpAndContactUxCleanUpEnabled) {
                <div>
                    <form #contactForm="ngForm" action autocomplete="off" class="helpContact" name="contactForm" novalidate>
                        @if (
                            initData.enableHelpAndContactPhase2 &&
                            initData.csMessage !== null &&
                            initData.csMessage !== undefined &&
                            !isNullOrUndefined(initData.csMessage.text)
                        ) {
                            <div class="cs-panel">
                                <div class="csMsg" [vnDynamicHtml]="initData.csMessage.text"></div>
                            </div>
                        }
                        @if (!optionsScreen) {
                            <div class="portal-center-wrapper" id="helpandcontactForm">
                                <h2 class="helpcontact-contactfaq">{{ initData.helpContactContent.messages.HelpText }}</h2>
                                <!-- Category -->
                                @for (cl of initData.newCategoriesList; track i; let i = $index) {
                                    <div class="form-element">
                                        <input
                                            class="custom-control-input custom-control-radio"
                                            name="contactRadio"
                                            type="radio"
                                            [checked]="cl.checked"
                                            [id]="'contactRadio' + i"
                                            (click)="selectedCategoryList(cl)" />
                                        <label class="custom-control-label" [for]="'contactRadio' + i" [innerHtml]="cl.category.parent.title"></label>
                                    </div>
                                }
                                <!-- SubCategory -->
                                <div id="Category">
                                    @if (categorySelected) {
                                        <div>
                                            <h2 class="helpcontact-contactfaq" [innerHtml]="initData.helpContactContent.messages.Faq"></h2>
                                            @for (sl of subCategoryList; track i; let i = $index) {
                                                <div class="form-element">
                                                    <input
                                                        class="custom-control-input custom-control-radio"
                                                        name="contactSubRadio"
                                                        type="radio"
                                                        [checked]="sl.checked"
                                                        [id]="'contactSubRadio' + i"
                                                        (click)="selectedSubCategoryList(sl)" />
                                                    <label class="custom-control-label" [for]="'contactSubRadio' + i" [innerHtml]="sl.title"></label>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <!-- YesOrNo -->
                                <div id="SubCategory">
                                    @if (selectedSubCategory) {
                                        <div>
                                            <h2 [innerHtml]="currentSelectedSubCategory.value.copyTitle"></h2>
                                            <div [vnDynamicHtml]="currentSelectedSubCategory.value.copy"></div>
                                            @if (!loggedInUser) {
                                                <div class="pc-txt" [innerHtml]="content.messages!.LoginText"></div>
                                            }
                                            <br />
                                            <p [innerHtml]="content.messages!.MoreHelpText"></p>
                                            <div id="helpcontact-buttons">
                                                <button
                                                    class="btn de-emphasize btn-light w-50"
                                                    id="helpcontact-yesbtn"
                                                    type="button"
                                                    (click)="goToOptions()">
                                                    {{ initData.helpContactContent.messages.YesButton }}
                                                </button>
                                                <button
                                                    class="btn de-emphasize btn-light w-50"
                                                    id="helpcontact-nobtn"
                                                    type="button"
                                                    (click)="gotoLastKnownProduct('FAQ', 'NO')">
                                                    {{ initData.helpContactContent.messages.NoButton }}
                                                </button>
                                            </div>
                                            <p
                                                class="pc-txt"
                                                [innerHtml]="currentSelectedSubCategory.value.footer"
                                                (click)="faqLinkClick($event)"></p>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </form>
                </div>
            }
            @if (initData.helpAndContactUxCleanUpEnabled) {
                <div>
                    <form
                        #contactForm="ngForm"
                        action
                        autocomplete="off"
                        name="contactForm"
                        novalidate
                        [ngClass]="{ helpContactNew: v2NavEnabledPreLogin }">
                        @if (v2NavEnabledPreLogin) {
                            <div class="helpcontact-header padding-content">
                                <span class="theme-contact helpcontact-icon"></span>
                                <div class="helpcontact-iconheader">
                                    <div class="helpcontact-mainheader" [innerHTML]="initData.helpContactContent.title"></div>
                                    <div class="helpcontact-subheader" [innerHTML]="initData.helpContactContent.messages.HelpContactSubHeading"></div>
                                </div>
                            </div>
                        }
                        <vn-message-panel></vn-message-panel>
                        @if (!optionsScreen) {
                            <div class="portal-center-wrapper helpcontactNewUx padding-content" id="helpandcontactForm">
                                <div class="helpcontact-category" [ngClass]="{ 'helpcontact-category-v2': v2NavEnabled && loggedInUser }">
                                    <div class="helpcontact-categoryheader" [innerHTML]="initData.helpContactContent.messages.Topics"></div>
                                    <!-- Category -->
                                    <div class="helpcontact-categorysection">
                                        @for (cl of initData.newCategoriesList; track i; let i = $index) {
                                            <div class="form-element card">
                                                <input
                                                    class="custom-control-input custom-control-radio"
                                                    name="contactRadio"
                                                    type="radio"
                                                    [checked]="cl.checked"
                                                    [id]="'contactRadio' + i"
                                                    (click)="selectedCategoryList(cl)" />
                                                <label
                                                    class="custom-control-label helpcontact-categorysection-label"
                                                    [for]="'contactRadio' + i"
                                                    [innerHtml]="cl.category.parent.title"></label>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <!-- SubCategory -->
                                <div id="Category">
                                    <div class="helpcontact-subcategory">
                                        <div class="helpcontact-subcategoryheader" [innerHTML]="currentSelectedCategoryName"></div>
                                        @if (categorySelected) {
                                            <div class="helpcontact-subcategorysection">
                                                @for (sl of subCategoryList; track i; let i = $index) {
                                                    <div class="form-element">
                                                        <div class="card">
                                                            <input
                                                                class="custom-control-input custom-control-radio"
                                                                name="contactSubRadio"
                                                                type="radio"
                                                                [checked]="sl.checked"
                                                                [id]="'contactSubRadio' + i"
                                                                (click)="selectedSubCategoryList(sl, $event)" />
                                                            <label
                                                                class="custom-control-label"
                                                                [for]="'contactSubRadio' + i"
                                                                [innerHtml]="sl.title"></label>
                                                        </div>
                                                        <!-- YesOrNo -->
                                                        <div class="subCategory">
                                                            @if (
                                                                selectedSubCategory && sl.value.metadata.id.itemName == currentSelectedSubCatergoryId
                                                            ) {
                                                                <div>
                                                                    <h2 [innerHtml]="currentSelectedSubCategory.value.copyTitle"></h2>
                                                                    <div [vnDynamicHtml]="currentSelectedSubCategory.value.copy"></div>
                                                                    @if (!loggedInUser) {
                                                                        <div class="pc-txt" [innerHtml]="content.messages!.LoginText"></div>
                                                                    }
                                                                    @if (
                                                                        initData.showNewDocumentUploadOption &&
                                                                        currentSelectedSubCategory.value.preFooterContent
                                                                    ) {
                                                                        <div>
                                                                            <div class="mt-3" id="newdocUploadCard">
                                                                                <div class="card card--clickable card-bg bonus-card">
                                                                                    <div
                                                                                        [vnDynamicHtml]="
                                                                                            currentSelectedSubCategory.value.preFooterContent
                                                                                        "></div>
                                                                                    <div
                                                                                        class="button-bottom-margin"
                                                                                        [ngClass]="{ 'text-center': !this.isMobile }">
                                                                                        <button
                                                                                            class="btn btn-primary"
                                                                                            type="button"
                                                                                            [innerHTML]="
                                                                                                currentSelectedSubCategory.value.preFooterButton
                                                                                            "
                                                                                            [ngClass]="{ 'w-50': !isMobile, 'w-100': isMobile }"
                                                                                            (click)="
                                                                                                goToDocumentUpload(
                                                                                                    currentSelectedSubCategory.value.preFooterButton
                                                                                                )
                                                                                            "></button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <p
                                                                        [innerHtml]="content.messages!.MoreHelpText"
                                                                        [ngClass]="{
                                                                            'mt-3': !(
                                                                                initData.showNewDocumentUploadOption &&
                                                                                currentSelectedSubCategory.value.preFooterContent
                                                                            ),
                                                                        }"></p>
                                                                    <div id="helpcontact-buttons">
                                                                        <button
                                                                            class="btn de-emphasize btn-light w-50"
                                                                            id="helpcontact-yesbtn"
                                                                            type="button"
                                                                            (click)="goToOptions()">
                                                                            {{ initData.helpContactContent.messages.YesButton }}
                                                                        </button>
                                                                        <button
                                                                            class="btn de-emphasize btn-light w-50"
                                                                            id="helpcontact-nobtn"
                                                                            type="button"
                                                                            (click)="gotoLastKnownProduct('FAQ', 'NO')">
                                                                            {{ initData.helpContactContent.messages.NoButton }}
                                                                        </button>
                                                                    </div>
                                                                    <p
                                                                        class="pc-txt"
                                                                        [innerHtml]="currentSelectedSubCategory.value.footer"
                                                                        (click)="faqLinkClick($event)"></p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            }
            @if (showchathistory && !optionsScreen) {
                <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                    <div class="chathistorycard card card--clickable">
                        <div class="cursorPointer d-flex align-vertically">
                            <div class="{{ initData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                            <div class="chatbonuscard option-font align-left m-2">
                                <div class="align-text-in-mobile m-3">
                                    <div class="heading">{{ initData.chatHistoryContent.title }}</div>
                                    <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                        <p>{{ initData.chatHistoryContent.messages.ChatHistory }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
    @if (optionsScreen) {
        <div>
            <pt-contact-options
                [contactData]="initData"
                [currentSelectedSubCategory]="currentSelectedSubCategory"
                [faqLink]="faqLink"
                [helpAndContactData]="helpAndContactData"
                [optionsScreen]="optionsScreen"
                [selectedCategory]="currentSelectedCategory"
                [showEmail]="showEmail"
                [showPhone]="showPhone"
                [twitterLink]="twitterLink"
                (onEmailScreenLoad)="emailScreenLoad($event)"
                (onEmailSelected)="enableEmailScreen($event)"
                (onPhoneSelected)="enablePhoneScreen($event)"></pt-contact-options>
        </div>
    }
</ng-template>
